import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import { size } from '@/helpers/lodash';
import ConnectTilesVerticalStack from '@/components/app/ConnectTiles/ConnectTilesVerticalStack';
import Stat from '@/components/app/Stat';
import GenreBadges from '@/components/component-library/GenreBadges';
import Text from '@/components/component-library/Text';
import { classes } from '@/helpers/styling';
import ButtonCTA from '@/components/component-library/Button/CTA';
import { getTicketsPlatform } from '@/helpers/supported-platforms';
import Translation from '@/components/component-library/Translation';

const DEFAULT_VALUE = '-';

const InfoRow = ({ children }) => (
  <div className={styles.infoRow}>
    {children}
  </div>
);

InfoRow.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

const AboutPanel = ({
  className,
  genres,
  hosts,
  loading,
  links,
  origin,
  releaseYear
}) => {
  const hostsExist = !!size(hosts);
  const multipleHosts = size(hosts) > 1;

  const buyTicketsLinkObject = useMemo(() => getTicketsPlatform({ links }) || {}, [links]);
  const buyTicketsLinkUrl = buyTicketsLinkObject.url;

  return (
    <div className={classes(styles.aboutPanel, className)}>
      {!!buyTicketsLinkUrl && (
        <InfoRow>
          <ButtonCTA
            href={buyTicketsLinkUrl}
            isRectangular
            loading={loading}
            openInNewTab
          >
            Buy Tickets
          </ButtonCTA>
        </InfoRow>
      )}
      <InfoRow>
        <Text bold className={styles.genresLabel} loading={loading} useHeaderFont>
          Genres
        </Text>
        <GenreBadges enableLinks genres={genres} loading={loading} />
      </InfoRow>
      {hostsExist && (
        <InfoRow>
          <Stat
            fullWidth
            loading={loading}
            title={`Hosts (${size(hosts)})`}
            value={multipleHosts ? hosts.join('\n ') : hosts[0]}
            wrapText
          />
        </InfoRow>
      )}
      {!!releaseYear && (
        <InfoRow>
          <Stat
            fullWidth
            loading={loading}
            title="Released"
            value={releaseYear}
          />
        </InfoRow>
      )}
      {!!origin && (
        <InfoRow>
          <Stat
            fullWidth
            loading={loading}
            title="From"
            value={origin || DEFAULT_VALUE}
          />
        </InfoRow>
      )}
      <ConnectTilesVerticalStack links={links} loading={loading} />
    </div>
  );
};

AboutPanel.propTypes = {
  className: PropTypes.string,
  genres: PropTypes.arrayOf(PropTypes.object),
  hosts: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool,
  links: PropTypes.array,
  origin: PropTypes.string,
  releaseYear: PropTypes.number
};

AboutPanel.defaultProps = {
  className: '',
  genres: [],
  hosts: null,
  links: [],
  loading: false,
  origin: null,
  releaseYear: null
};

export default memo(AboutPanel);
